import React, { Fragment, useState, useEffect, useContext } from 'react'

import AppContext from '../../../contexts/AppContext'
import Breadcrumbs from '../../Breadcrumbs'
import Header from '../../Header'
import Footer from '../../Footer'
import { breadcrumbsBy } from '../../../services/locations'
import { placementKeyBy, convertBanner, convertLocations } from '../../../services/banners'
import BannerForm from './Form'
import useToastContext from "../../../hooks/useToastContext"

import { BannerStatusBages, BannerActionButtons } from './common'

import { Helmet } from "react-helmet-async"

const BannerEdit = ({ match, history }) => {

    const { data, authServices, location, postServices, bannerServices, imageServices } = useContext(AppContext)
    const { user } = data.app

    const addToast = useToastContext()

    const banner_id = match.params.id
    const title = "Edit Banner Ad"

    const [ isChecked, setIsChecked ] = useState(false)

    const [ placement, setPlacement ] = useState(null)
    const [ banner, setBanner ] = useState(null)
    const [ dbBanner, setDbBanner ] = useState(null)
    const [ locations, setLocations ] = useState([])
    const [ categories, setCategories ] = useState([])
    const [ images, setImages ] = useState([])
    const [ dataToSave, setDataToSave ] = useState({})


    const setBannerData = _banner => {
        const bannerPlacement = _banner.placements && _banner.placements[0] ? _banner.placements[0] : null

        if(_banner){
            setBanner(convertBanner(_banner))
            setDbBanner(_banner)
        }

        if(bannerPlacement){
            if(bannerPlacement.locations) setLocations(convertLocations(bannerPlacement.locations))
            if(bannerPlacement.categories && bannerPlacement.categories.length > 0){
                setCategories(bannerPlacement.categories)
            }
        }

        setPlacement(placementKeyBy(_banner))
    }

    const loadBannerData = () => {
        bannerServices.show(banner_id, {placement: 'y'}).then(res => {
            setIsChecked(false)
            setBannerData(res.banner)
            setIsChecked(true)
        }).catch(res => {
            console.log('error')
            setIsChecked(true)
        })
    }

    useEffect(loadBannerData, [])

    const onSave = (data, shouldPublish) => {
        return new Promise((resolve, reject) => {
            const banner_id = data.banner.banner_id
            return bannerServices.update(banner_id, data).then(res => {
                const bannerUpdated = res.banner

                setBannerData(bannerUpdated)

                var tasks = []

                if(typeof data.uploadImage == 'object'){
                    tasks.push(
                        imageServices.upload(data.uploadImage, banner_id, 'App\\Banner', {replace: true}).then(res => {
                            console.log('the banner update success')
                        }).catch(res => {
                            const message = res && res.data && res.data.errors && res.data.errors.image ? res.data.errors.image.join(' ') : res.data.message ? res.data.message : null
                            if(message) addToast({title: 'Error', message: message, type: 'danger'})

                        })
                    )
                }

                const image_id = data.banner && data.banner.options && data.banner.options.settings && data.banner.options.settings.image_id
                if((image_id && typeof image_id == 'string' && image_id.includes('default-')) || bannerUpdated.type == 'text-line' ){
                    const activeImages = bannerUpdated.images.filter(item => typeof item.id == 'number' && item.id > 0)
                    for(var i = 0; i < activeImages.length; i ++){
                        tasks.push(
                            imageServices.delete(activeImages[i].id).then(res => {
                                console.log('the banner image delete success')
                                resolve()
                            }).catch(res => {
                                console.log(res)
                            })
                        )
                    }
                }

                if(tasks.length > 0){
                    return Promise.all(tasks).then(() => {
                        if(shouldPublish){
                            history.push('/account/banner/pay/' + bannerUpdated.id)
                        }else{
                            loadBannerData()
                            resolve()
                        }
                    }).catch(reject)
                }else{
                    if(shouldPublish){
                        history.push('/account/banner/pay/' + bannerUpdated.id)
                    }else{
                        resolve()
                    }
                }
            }).catch(res => {
                if(res && res.data && res.data.message) addToast({title: 'Error', message: res.data.message, type: 'danger'})
                reject(res && res.data)
            })
        })
    }

    const status_text = banner ? {0: 'Draft', 1: 'Under review', 2: 'Published', 3: 'Rejected'}[banner.banner_status] : null

    return (
        <Fragment>
            <div>
                <Header history={history} />
                <main className="py-4">
                    <div className="container">
                        <Breadcrumbs list={breadcrumbsBy(location, [{url: '/account', title: 'Dashboard'}, {url: '/account/banner/list', title: 'Banner ads list'}, {title}])} />
                        <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>

                        <div className="d-flex justify-content-between flex-wrap">
                            <div className="me-3">
                                <h1 className="mt-0">
                                    <span className="me-2">{dbBanner && ('#' + dbBanner.id)} {title}</span>
                                    <BannerStatusBages banner={dbBanner} />
                                </h1>
                            </div>
                            <BannerActionButtons
                                page="edit"
                                banner={dbBanner}
                                onSave={() => onSave(dataToSave)}
                                onOrder={() => onSave(dataToSave, true)}
                            />
                        </div>

                        {isChecked && banner &&
                            <BannerForm
                                initBanner={banner}
                                hasBeenPaid={dbBanner.has_been_paid > 0 ? true : false}
                                initPlacement={placement}
                                initLocations={locations}
                                initCategories={categories}
                                postImages={images}
                                updateDataToSave={data => setDataToSave(data)}
                            />
                        }
                    </div>
                </main>
            </div>
            <Footer />
        </Fragment>
    )
}

export default BannerEdit
